import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureSectionProp } from ".";




const DivisionViewSection = (props: ControlFailureSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 10]}>
                <Col span={24} className="form-list-item">
                    <Form.Item
                        label={t("ControlFailure.lbExperienceOfEvent")}
                    >
                    </Form.Item>
                </Col>

                {
                    data.loss_event_experiences && data.loss_event_experiences.map((item, index) => (
                        <Col key={index} span={24} className="form-list-item">
                            <Form.Item
                            >
                                <span>{item.division?.name} - {item.business_unit?.name} - {item.svp?.name}</span>
                            </Form.Item>
                        </Col>
                    ))
                }
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbYouBelieveTheLossExperienced")}>
                        <span>{data.other_areas_experience ? t("ControlFailure.lbYes") : t("ControlFailure.lbNo")}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]} className="has-check-box">
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbCauseOfEvent")}
                    >
                        <span>{data.caused_division?.name} - {data.caused_business_unit?.name} - {data.caused_svp?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbYouBelieveTheLossCaused")}>
                        <span>{data.other_areas_cause ? t("ControlFailure.lbYes") : t("ControlFailure.lbNo")}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default DivisionViewSection;